import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

import { VrcBrowserStorageService } from './vrc-browser-storage.service';
import { filter, of, switchMap, take } from 'rxjs';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';

export const vrcRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const _bst = inject(VrcBrowserStorageService);
  const _r = inject(Router);
  const _authService = inject(MsalService);
  const _msalBroadcastService = inject(MsalBroadcastService);
  let configuredRoles: Array<string> = route.data['roles'];
  let activeAccount: AccountInfo | undefined;
  try {
    activeAccount = _authService.instance.getActiveAccount() || _authService.instance.getAllAccounts()[0];
  } catch { }
  const checkAzureRoles = (): boolean => {
    if (activeAccount && activeAccount.idTokenClaims) {
      const claims = activeAccount.idTokenClaims as any;
      const roles: Array<string> = claims.roles || [];
      return roles.some(role => configuredRoles.includes(role));
    }

    return false;
  };
  const checkRoles = (): boolean => {
    if (_bst.roles && _bst.roles.length > 0) {
      return _bst.roles.some(role => configuredRoles.includes(role));
    }

    return false;
  };
  const handleUnauthorized = () => {
    if (_authService.instance.getAllAccounts().length > 0) {
      _authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    }
    _bst.clearAuthentication();
    _r.navigate(["login", { url: state.url }]);
    return false;
  };
  if(_bst.token){
    return checkRoles() ? true : handleUnauthorized();
  }
  if (activeAccount) {
    return checkAzureRoles() ? true : handleUnauthorized();
  }
  return _msalBroadcastService.msalSubject$.pipe(
    filter((msg: EventMessage) =>
      msg.eventType === EventType.HANDLE_REDIRECT_END ||
      msg.eventType === EventType.INITIALIZE_END
    ),
    take(1),
    switchMap(e => {
      activeAccount = _authService.instance.getActiveAccount() || _authService.instance.getAllAccounts()[0];
      return of(checkAzureRoles() ? true : handleUnauthorized());
    })
  );
}
